import { CONTIFICO_PRODUCT_URL, CONTIFICO_PRODUCT_URL_V2 } from '../constants';
import { apiSlice } from './apiSlice';

export const contificoProductApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProductContifico: builder.query({
            query: (searchValue) => {
                const isPlainCode = typeof searchValue === 'string';
                const company = !isPlainCode ? searchValue?.company : undefined;
                const params = isPlainCode
                    ? { codigo: searchValue }
                    : {
                          ...(searchValue?.codigo ? { codigo: searchValue.codigo } : {}),
                          ...(searchValue?.codigo_barra
                              ? { codigo_barra: searchValue.codigo_barra }
                              : {}),
                          ...(company ? { company } : {}),
                      };

                return {
                    url: CONTIFICO_PRODUCT_URL,
                    method: 'GET',
                    params,
                };
            },
        }),
        getAllProductsContifico: builder.query({
            query: ({ pageNumber, pageSize, keyword, company }) => ({
                url: `${CONTIFICO_PRODUCT_URL_V2}`,
                method: 'GET',
                params: {
                    page: pageNumber,
                    page_size: pageSize,
                    search: keyword,
                    company,
                },
            }),
            providesTags: (result, error, { pageNumber }) =>
                result
                    ? [
                          ...result.results.map(({ id }) => ({ type: 'ContificoProducts', id })),
                          { type: 'ContificoProducts', id: `LIST-${pageNumber}` },
                      ]
                    : [{ type: 'ContificoProducts', id: `LIST-${pageNumber}` }],
        }),
        updateProductContifico: builder.mutation({
            query: ({ productId, data }) => ({
                url: `${CONTIFICO_PRODUCT_URL_V2}/${productId}/`,
                method: 'PUT',
                body: data,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: (result, error, { productId }) => [
                { type: 'ContificoProducts', id: productId },
            ],
        }),
    }),
});

export const {
    useGetProductContificoQuery,
    useLazyGetProductContificoQuery,
    useGetAllProductsContificoQuery,
    useUpdateProductContificoMutation,
} = contificoProductApiSlice;